import React from "react";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import logo from '../../assetImages/undraw_personal_opinions_g3kr.svg';

class SupportWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        window.scrollTo(0, 0)
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Container maxWidth="sm" component="main" className={appStyle.supportContentHeader}>

                <div className={appStyle.imgbox}>
                    <img className={appStyle.centerFit} src={logo}/>
                </div>

                <Typography variant="h4" align="center" color="textPrimary" gutterBottom>
                    I'm happy for your feedback...
                </Typography>
                <Typography variant="h6" align="center" color="textSecondary" component="p">
                    <p><a href={'mailto:captureNpaste@gmail.com'}>captureNpaste@gmail.com</a></p>
                </Typography>
            </Container>
        );
    }
}

export default SupportWidget;